import { dataArrowToTopSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowToTopSolid = /*#__PURE__*/createIcon(dataArrowToTopSolid)
export default IconArrowToTopSolid
